export const API_URL = '/api/';
export const USERAPI_URL = '/api/';
export const USERMASTERAPIHOME = '/api/UserLogin/';
export const MODULEROLEACCESSAPIHOME = '/api/ModuleRoleAccess/';
export const CONNECTSERVICE = 'api/ConnectAPIService/';


